import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'summaryCharts',
    label: 'Summary Charts',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
